































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
// import SecureCodeModule from '@/store/modules/SecureCode';
import ResetPasswordLogModule from '@/store/modules/ResetPasswordLog';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import moment from 'moment';

@Component({
  components: {
    Table,
  },
})
export default class ResetPasswordLog extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        displayName: 'securecode.operator',
      },
      {
        displayName: 'securecode.role',
      },
      {
        displayName: 'securecode.user',
      },
      {
        displayName: 'securecode.role',
      },
      {
        displayName: 'securecode.time',
      },
      {
        displayName: 'securecode.ip',
      },
    ],
  ];

  ResetPasswordLogInstance = getModule(ResetPasswordLogModule, this.$store);

  searchText = '';

  data = [];

  historyPage = 1;

  async fetchResetLog() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ResetPasswordLogInstance.FetchResetLog({ username: this.searchText });
    if (res.code) {
      this.checkError(res);
    }
    const dataList = res.list.map((item) => ({
      ...item,
      timestamp: moment(item.timestamp).add(-1, 'h').format('DD/MM/YYYY, hh:mm:ss a'),
    }));
    this.data = dataList;
    this.GeneralInstance.toggleLoading(false);
  }

  onSubmit() {
    this.fetchResetLog();
  }
}
